import { faBarcode } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useState } from "react";
import {
  Alert,
  Button,
  Card,
  Form,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import { AlertOctagon } from "react-feather";
import toast from "react-hot-toast";

import claimsService from "../../../../services/claim.service";
import { getItem } from "../../../../services/inspect/inspect.service";

import { InspectContext } from "../../Inspect";

const LPNForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [lpnValue, setLpnValue] = useState("");
  const [error, setError] = useState("");

  const { setCurrentItem } = useContext(InspectContext);

  const submit = async () => {
    // Check for input errors.
    if (!lpnValue) {
      toast.error("Please enter an LPN / RPN.");
      return;
    }

    if (lpnValue.toUpperCase() === "W") {
      toast.error("Please re-scan LPN / RPN or enter it manually.");
      setLpnValue("");
      return;
    }

    // Fetch the item data.
    try {
      setIsSubmitting(true);
      const getItemResponse = await getItem({ lpn: lpnValue });

      if (
        getItemResponse.success &&
        Object.keys(getItemResponse.processingItem.processingData).length !== 0
      ) {
      } else {
        toast.error(`No item found for LPN: ${lpnValue}`);
        setLpnValue("");
        setError("");
        setIsSubmitting(false);
        return;
      }

      // Check to see if a damage report has been made.
      const getDamageReportResponse = await claimsService.getClaims({
        lpn: lpnValue,
      });

      if (
        getDamageReportResponse.success &&
        getDamageReportResponse.reports.length === 1
      ) {
        const report = getDamageReportResponse.reports[0];
        const imagesResponse = await claimsService.getClaimImages(
          report.reportId
        );

        if (imagesResponse.success) {
          report.reportImages = imagesResponse.reportImages;
        }
        getItemResponse.processingItem.processingData.claim = report;
      }

      setIsSubmitting(false);
      setCurrentItem(getItemResponse.processingItem);
    } catch (error) {
      setIsSubmitting(false);
      setError(error.response.data.message);
      console.log(error);
    }
  };

  return (
    <Card>
      <div>
        <Card.Header className="d-flex justify-content-start border-bottom">
          <FontAwesomeIcon icon={faBarcode} size="3x" className="me-3" />
          <div>
            <Card.Title>LPN / RPN</Card.Title>
            <Card.Subtitle>
              Scan or enter an LPN or RPN number to begin inspecting the item.
            </Card.Subtitle>
          </div>
        </Card.Header>
        <Card.Body>
          {error && (
            <Alert variant="danger" className="flex-fill alert-blink">
              <div className="alert-icon">
                <AlertOctagon
                  className="position-relative top-50 start-50 translate-middle"
                  size={20}
                />
              </div>
              <div className="alert-message font-weight-bold">{error}</div>
            </Alert>
          )}
          <Form.Label>LPN / RPN Number</Form.Label>
          <InputGroup className="mb-3">
            <Form.Control
              required
              autoFocus
              size="lg"
              placeholder="Scan or Enter LPN / RPN Number..."
              value={lpnValue}
              onChange={(e) => setLpnValue(e.target.value)}
              onFocus={(e) => {
                e.target.select();
              }}
              onKeyUp={(e) => {
                if (e.key === "Enter") {
                  submit();
                }
              }}
              disabled={isSubmitting}
            />
            <Button variant="primary" onClick={submit} disabled={isSubmitting}>
              {isSubmitting && (
                <Spinner
                  className="me-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              {isSubmitting ? "Submitting..." : "Submit"}
            </Button>
          </InputGroup>
        </Card.Body>
      </div>
    </Card>
  );
};

export default LPNForm;
